import { fetcher } from "helpers/fetcher";

import { TDuplicateOrganizationReq, TDuplicateOrganizationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const duplicateOrganization = async (
  payload?: TDuplicateOrganizationReq
) => {
  return await fetcher<
    TDuplicateOrganizationRes,
    TDuplicateOrganizationReq["data"]
  >(ENDPOINT.CORPORATION.DUPLICATE_ORGANIZATION, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.DUPLICATE_ORGANIZATION.version,
      [API_HEADER.CORP_ID]: payload?.idCorp,
    },
  });
};

export const mutationDuplicateOrganization = async (
  payload?: TDuplicateOrganizationReq
) => {
  return (await duplicateOrganization(payload)).data;
};

mutationDuplicateOrganization._key = (payload?: TDuplicateOrganizationReq) => [
  ENDPOINT.CORPORATION.DUPLICATE_ORGANIZATION.url,
  payload,
];
